module.exports = __webpack_public_path__ + "static/img/1076_big.d55807d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1076_big.png
// module id = 97wv
// module chunks = 1